import React, { createContext, useCallback, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { debounce } from '../../js/debounce';
export const RRouterSearchParamsContext = createContext(null);
export const RRouterSearchParamsProvider = ({ children, navProps }) => {
    const dependencyHandlers = useRef({});
    const [searchParams, setSearchParams] = useSearchParams();
    const debouncedSetSearchParams = useCallback(debounce((searchParams) => {
        searchParams.sort();
        setSearchParams(searchParams, navProps);
    }, 0), [setSearchParams]);
    const setSearchParam = ({ key, value }) => {
        if (value === null) {
            searchParams.delete(key);
        }
        else {
            searchParams.set(key, value);
        }
        dependencyHandlers.current[key]?.forEach(handler => { handler(searchParams, setSearchParam); });
        debouncedSetSearchParams(searchParams);
    };
    const addDependencyHandler = (handler, dependencyKeys) => {
        let isNew = false;
        dependencyKeys.forEach(depKey => {
            if (dependencyHandlers.current[depKey]?.includes(handler) !== true) {
                dependencyHandlers.current[depKey] = [
                    ...(dependencyHandlers.current[depKey] ?? []),
                    handler
                ];
                isNew = true;
            }
        });
        isNew && handler(searchParams, setSearchParam);
    };
    return (React.createElement(RRouterSearchParamsContext.Provider, { value: [searchParams, setSearchParam, addDependencyHandler] }, children));
};
